import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import "../../../assets/css/student/solutions/InvolvedSection.css";

function InvolvedSection() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleDonation = () => {
    setLoading(true);
    setTimeout(() => {
      navigate('/donor/login');
    }, 1500);
  };

  const involvedOptions = [
    {
      id: 1,
      icon: 'bi-megaphone-fill',
      title: 'Campaigning',
      description: 'Become a champion for social media advocacy. Organize fundraising events and awareness campaigns.'
    },
    {
      id: 2,
      icon: 'bi-people-fill',
      title: 'Volunteering',
      description: 'Contribute your skills in education, healthcare, or administration. Join our local initiatives.'
    },
    {
      id: 3,
      icon: 'bi-award-fill',
      title: 'Membership',
      description: 'Gain exclusive access to events. Collaborate with like-minded individuals for lasting change.'
    }
  ];

  return (
    <section className="invs-involved-section">
      {/* Other Ways Section */}
      <div className="invs-other-ways-section">
        <Container>
          <div className="invs-section-header">
            <p className="invs-section-tag">Give your time</p>
            <h2 className="invs-section-title">Other ways to get involved</h2>
            <p className="invs-section-subtitle">
              Beyond donations, you can support us by campaigning for<br />
              change, and volunteering your time.
            </p>
          </div>

          <Row className="invs-involved-cards-row">
            {involvedOptions.map((option) => (
              <Col lg={4} md={6} sm={12} key={option.id} className="invs-involved-col">
                <div className="invs-involved-card">
                  <div className="invs-card-icon-box">
                    <i className={`bi ${option.icon}`}></i>
                  </div>
                  <h3 className="invs-card-title">{option.title}</h3>
                  <p className="invs-card-description">{option.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Campaign CTA Section */}
      <div className="invs-campaign-cta-section">
        <Container>
          <div className="invs-cta-content">
            <p className="invs-cta-tag">Get involved</p>
            <h2 className="invs-cta-title">Together we are stronger.</h2>
            <h3 className="invs-cta-subtitle">Help us campaign for change</h3>
            <p className="invs-cta-description">
              Whether you're an individual, a company or a charity, there<br />
              are plenty of ways to get involved.
            </p>
            <Button
              className={`invs-cta-button ${loading ? 'invs-cta-loading' : ''}`}
              onClick={handleDonation}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="invs-spinner"></span>
                  Loading...
                </>
              ) : (
                <>
                  Make a donation
                  <i className="bi bi-arrow-right ms-2"></i>
                </>
              )}
            </Button>
          </div>
        </Container>
      </div>
    </section>
  );
}

export default InvolvedSection;